export default "__VITE_ASSET__nnorRj3D__"